
export enum SurePayResponseCode {

  Success = 0,
  Declined = 1,
  ERR_CANCEL_KEY_PRESSED = -2,
  ERR_CANCEL_SWIPE_OR_INSERT = -25,
  ERR_TIMEOUT_SWIPE_OR_INSER = -26,

  ERR_FUN_NOT_SUPPORTED = -42,
  ERR_AMOUNT_NOT_FOUND = -43,
  ERR_NO_INCOMING_REQ = -44,
  ERR_CONFIRM_AMOUNT_CANCELE = -45,
  ERR_PIN_CANCELED = -46,
  ERR_ICC_TRX_FAILED = -48,
  ERR_TRX_NOT_ALLOWED = -49,


  ERR_MANUAL_ENTR_NOT_ALLOWED = -50,
  ERR_NOT_SUPPORTED = -51,
  ERR_NO_RECORDS = -52,
  ERR_NO_MORE_ACTION = -53,
  ERR_NO_AVAILABLE_REVERSAL = -54,
  ERR_CANNOT_BUILD_REVERSEAL = -55,
  ERR_REVERSAL_TIMER_EXPIRED = -56,
  ERR_REVERSAL_NOT_ALLOWED = -58,
  ERR_NO_CONNECTION = -59,

  ERR_COM_PORT_NOT_OPENED = -1000,
  ERR_FAILED_TO_SEND_DATA_TO_COM_PORT = -1001,
  ERR_FAILED_TO_RECEIVE_DATA_FROM_COM_PORT = -1002
  
}
